// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1ZX8c","rootSuccess":"CompleteLink_rootSuccess__2U4W1","rootFailure":"CompleteLink_rootFailure__1m_L7","isDisabled":"CompleteLink_isDisabled__1RAiW"};